export class ApiGatewayOptions {
  method: RequestMethods;
  url: string;
  headers: any = {};
  params = {};
  data = {};
  isTimer: boolean;
  responseType: ResponseContentType;
}

export enum RequestMethods {
  'Get' = 'GET',
  'Post' = 'POST',
  'Put' = 'PUT',
  'Delete' = 'DELETE',
  'Options' = 'OPTIONS',
  'Head' = 'HEAD',
  'Patch' = 'PATCH',
}

export enum ResponseContentType {
  Text = 'text',
  Json = 'json',
  ArrayBuffer = 'arrayBuffer',
  Blob = 'blob',
}
